import Icon from '../components/Icon.vue'

Icon.register({
  desktop: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 0H48C21.5 0 0 21.5 0 48V368C0 394.5 21.5 416 48 416H240L224 464H152C138.7 464 128 474.7 128 488S138.7 512 152 512H424C437.3 512 448 501.3 448 488S437.3 464 424 464H352L336 416H528C554.5 416 576 394.5 576 368V48C576 21.5 554.5 0 528 0zM512 352H64V64H512V352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/desktop.js
// module id = 5eTd
// module chunks = 144